// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/about/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/assets/about/honors_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@/assets/about/feature_plan.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@/assets/about/process.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@/assets/about/history_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  word-wrap: break-word;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
/* .content-wrapper > .tween-one-leaving,
.queue-anim-leaving {
  // position: absolute !important;
  // width: 100%;
} */
.video {
  max-width: 800px;
}
#react-content {
  min-height: 100%;
}
.home-page-wrapper p {
  padding: 0;
  margin: 0;
}
/* 详细页图片或框框的样式;
*/
.feature4-wrapper {
  min-height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.feature4-wrapper .feature4 {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 50px 24px;
}
.feature4-wrapper .feature4-text .title-wrapper {
  margin: 0 auto 35px;
}
.feature4-wrapper .feature4-text > *.queue-anim-leaving {
  position: relative !important;
}
.feature4-wrapper .feature4-text .title-h1 {
  position: relative;
  margin: 0 0 5px;
  text-align: left;
  font-size: 30.6px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.feature4-wrapper .feature4-text .title-content {
  position: relative;
  text-align: left;
  color: #3A4597;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.feature4-wrapper .feature4-text ul {
  position: relative;
  display: inline-block;
}
.feature4-wrapper .feature4-text ul li {
  margin-bottom: 24px;
}
.feature4-wrapper .feature4-text ul li .feature4-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: absolute;
}
.feature4-wrapper .feature4-text ul li .feature4-content {
  line-height: 1.8em;
  font-size: 16px;
  text-indent: 2em;
}
.feature4-wrapper .feature4-text ul li .feature4-title {
  font-size: 14px;
  margin-bottom: 10px;
  text-align: left;
  color: #3A4597;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.feature4-wrapper .feature4-number {
  font-size: 48px;
  color: #0070E2;
  font-weight: 700;
  font-family: Montserrat;
}
.feature4-wrapper .feature4-number-wrapper {
  text-align: left;
}
@media screen and (max-width: 576px) {
  .feature4-wrapper {
    padding: 10px;
    overflow: hidden;
  }
  .feature4-wrapper .feature4 {
    display: block;
  }
  .feature4-wrapper .feature4-img,
  .feature4-wrapper .feature4-text {
    display: block;
    width: 100%;
  }
  .feature4-wrapper .feature4-text > h1,
  .feature4-wrapper .feature4-text > p {
    text-align: center;
  }
  .feature4-wrapper .feature4-text > h1 {
    margin: 56px auto 16px;
  }
  .feature4-wrapper .feature4-text p {
    margin-bottom: 32px;
  }
  .feature4-wrapper .feature4-img {
    margin-top: 20px;
  }
  .feature4-wrapper .feature4-number {
    font-size: 36px;
  }
  .feature4-wrapper .feature4-number-wrapper {
    margin-bottom: 16px;
  }
  .feature4-wrapper .feature4-number-wrapper:nth-child(n+2) {
    text-align: center;
  }
  .feature4-wrapper .feature4-number-wrapper:nth-child(n+2) p {
    text-align: center;
  }
}
.teams1-wrapper {
  min-height: 446px;
  overflow: hidden;
}
.teams1-wrapper .teams1 {
  overflow: hidden;
  height: 100%;
  padding: 64px 24px;
}
.teams1-wrapper .teams1 > .title-wrapper {
  margin: 0 27px 48px;
}
.teams1-wrapper .teams1 > .title-wrapper .title-h1 {
  position: relative;
  margin: 0 0 5px;
  text-align: left;
  font-size: 30.6px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.teams1-wrapper .teams1 > .title-wrapper .title-content {
  position: relative;
  margin-bottom: 64px;
  text-align: left;
  color: #3A4597;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.teams1-wrapper .teams1 .team-container {
  width: 100%;
  min-height: 530px;
  margin: 0 27px 48px;
  overflow: hidden;
}
.teams1-wrapper .teams1 .team-container label {
  display: block;
  height: 140px;
  float: left;
  margin-right: 20px;
}
.teams1-wrapper .teams1 .team-container label:nth-child(3) {
  border: none;
}
.teams1-wrapper .teams1 .team-container label input:checked ~ div {
  width: 30vw;
}
.teams1-wrapper .teams1 .team-container label input {
  display: none;
}
.teams1-wrapper .teams1 .team-container label .city-container {
  position: relative;
  overflow: hidden;
  width: 15vw;
  transition: all 0.5s ease;
  border-radius: 20px;
}
.teams1-wrapper .teams1 .team-container label .city-container .city-name {
  position: absolute;
  top: 300px;
  left: 58px;
  color: #FFF;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.teams1-wrapper .teams1 .team-container label .city-container .city-address {
  position: absolute;
  top: 350px;
  left: 62px;
  color: #FFF;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media screen and (max-width: 767px) {
  .teams1-wrapper {
    min-height: 1000px;
    overflow: hidden;
  }
  .teams1-wrapper .teams1 .team-container {
    width: 100%;
    min-height: 1000px;
    margin: 0;
    overflow: hidden;
  }
  .teams1-wrapper .teams1 .team-container .city-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 250px;
    margin-bottom: 20px;
  }
  .teams1-wrapper .teams1 .team-container .city-container img {
    border-radius: 20px;
  }
  .teams1-wrapper .teams1 .team-container .city-container .city-name {
    position: absolute;
    top: 120px;
    left: 10px;
    color: #FFF;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .teams1-wrapper .teams1 .team-container .city-container .city-address {
    position: absolute;
    top: 160px;
    left: 10px;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 300px;
    white-space: pre-wrap;
  }
}
.feature6-wrapper {
  min-height: 360px;
  margin: 0 auto;
  overflow: hidden;
}
.feature6-title {
  display: inline-block;
}
.feature6-title-wrapper {
  text-align: center;
  margin-bottom: 48px;
}
.feature6-title-text {
  display: inline-block;
  margin: 0 72px;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  transition: color 0.45s ease-in-out;
  cursor: pointer;
}
.feature6-title-text.active {
  color: #0070E2;
}
.feature6-title-bar {
  height: 6px;
  background: #0070E2;
  width: 20%;
  margin: auto;
  display: block;
}
.feature6-title-bar-wrapper {
  position: relative;
  margin-top: 8px;
  transition: left 0.45s ease-in-out;
}
.feature6-number,
.feature6-text {
  text-align: left;
}
.feature6-number {
  font-size: 48px;
  color: #0070E2;
  font-weight: 700;
  font-family: Montserrat;
}
.feature6-number-wrapper {
  text-align: left;
}
.feature6-text {
  font-size: 20px;
}
.feature6-unit {
  font-size: 16px;
  color: #0070E2;
}
.feature6 .ant-carousel .slick-dots-bottom {
  bottom: -24px;
}
.feature6 .ant-carousel .slick-dots li button {
  background: rgba(0, 112, 226, 0.3);
}
.feature6 .ant-carousel .slick-dots li.slick-active button {
  background: #0070E2;
}
@media screen and (max-width: 576px) {
  .feature6-wrapper {
    padding-bottom: 0;
  }
  .feature6-title-text {
    margin: 0 14px;
  }
  .feature6-title-bar {
    width: 40%;
  }
  .feature6-number {
    font-size: 36px;
  }
  .feature6-number-wrapper {
    margin-bottom: 16px;
    text-align: center;
  }
  .feature6-number-wrapper p {
    text-align: center;
  }
}
.feature7-wrapper {
  min-height: 564px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #f7f9fc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}
.feature7-wrapper.home-page-wrapper .home-page {
  padding: 64px 24px;
}
.feature7-title-wrapper {
  text-align: center;
  margin-bottom: 40px;
}
.feature7-title-h1 {
  padding-left: 24px;
  font-size: 30.6px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.feature7-title-content {
  padding-left: 24px;
  margin-top: 16px;
  text-align: left;
  color: #3A4597;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.feature7-text {
  margin: 100px 0 0 350px ;
}
.feature7 ul li {
  list-style-type: circle;
}
.feature7 ul li:last-child {
  list-style-type: none;
}
.feature7 ul .content7-content {
  padding: 0 0 25px 10px;
}
@media screen and (max-width: 767px) {
  .feature7-wrapper {
    min-height: 840px;
  }
  .feature7-wrapper.home-page-wrapper .home-page {
    padding: 56px 24px;
  }
  .feature7-wrapper.home-page-wrapper .home-page .feature7-mobile .active {
    color: #0070E2;
  }
}
.plan-wrapper {
  padding-bottom: 64px;
}
.plan-wrapper.home-page-wrapper {
  overflow: initial;
}
.plan-wrapper .plan {
  min-height: 450px;
  padding: 64px 0 0;
}
.plan-wrapper .plan-body {
  min-height: 540px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: contain;
}
.plan-wrapper .timeline {
  position: relative;
}
.plan-wrapper .timeline:before {
  display: block;
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  width: 0;
  height: calc(100% - 108px);
  margin: 34px 0;
  border-left: 2px #ebedf0 dashed;
}
.plan-wrapper .block-wrapper {
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  position: relative;
  margin-bottom: 70px;
  min-height: 160px;
}
.plan-wrapper .block-wrapper:last-child {
  margin-bottom: 0;
}
.plan-wrapper .image-wrapper,
.plan-wrapper .text-wrapper {
  width: 50%;
}
.plan-wrapper .image-wrapper {
  text-align: center;
}
.plan-wrapper .image-wrapper .block-img,
.plan-wrapper .image-wrapper .name-wrapper {
  float: right;
  clear: both;
  width: 262px;
  margin: auto;
}
.plan-wrapper .image-wrapper .block-img {
  height: 98px;
}
.plan-wrapper .image-wrapper .block-img img {
  height: 100%;
}
.plan-wrapper .image-wrapper .name-wrapper {
  margin: 16px 0 0;
}
.plan-wrapper .image-wrapper .name-wrapper .block-name {
  font-size: 14px;
  margin-bottom: 4px;
}
.plan-wrapper .image-wrapper .name-wrapper .block-post {
  font-size: 12px;
  color: #697b8c;
}
.plan-wrapper .text-wrapper {
  padding-left: 40px;
}
.plan-wrapper .text-wrapper .block-time {
  font-size: 12px;
  color: #697b8c;
  line-height: 18px;
  min-height: 18px;
}
.plan-wrapper .text-wrapper .block-title {
  margin: 8px 0 12px;
  font-size: 14px;
  position: relative;
  min-height: 18px;
}
.plan-wrapper .text-wrapper .block-icon {
  position: absolute;
  left: -40px;
  transform: translateX(calc(-50% + 1px));
}
.plan-wrapper .text-wrapper .block-content {
  width: 300px;
  color: #314659;
  font-size: 12px;
  min-height: 18px;
}
@media screen and (max-width: 767px) {
  .plan-wrapper {
    padding-bottom: 0;
  }
  .plan-wrapper .plan {
    min-height: 350px;
    padding: 64px 24px;
  }
  .plan-wrapper .plan-body {
    min-height: 300px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: contain;
  }
  .plan-wrapper .timeline:before {
    left: 0;
    height: 100%;
    margin: 0;
  }
  .plan-wrapper .block-wrapper {
    display: block;
    min-height: 100px;
    margin-bottom: 54px;
  }
  .plan-wrapper .image-wrapper,
  .plan-wrapper .text-wrapper {
    width: 100%;
  }
  .plan-wrapper .image-wrapper .block-img {
    display: none;
  }
  .plan-wrapper .image-wrapper .name-wrapper {
    text-align: left;
    float: left;
    width: 100%;
    padding-left: 40px;
    margin: auto;
  }
  .plan-wrapper .image-wrapper .block-name,
  .plan-wrapper .image-wrapper .block-post {
    display: inline-block;
  }
  .plan-wrapper .image-wrapper .block-name {
    margin-right: 8px;
  }
  .plan-wrapper .text-wrapper .block-content {
    display: none;
  }
  .plan-wrapper .text-wrapper .block-title {
    font-size: 16px;
  }
}
.content9-wrapper {
  position: relative;
  margin-top: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  padding-bottom: 64px;
}
.content9-wrapper .content-btn-left,
.content9-wrapper .content-btn-right {
  position: absolute;
  top: 70%;
  z-index: 11;
}
.content9-wrapper .content-btn-left {
  left: -40px;
}
.content9-wrapper .content-btn-right {
  right: -40px;
}
.content9-wrapper .content9 {
  min-height: 350px;
}
.content9-wrapper .content9.home-page-wrapper {
  overflow: initial;
}
.content9-wrapper .content9 .title-wrapper .title-h1 {
  position: relative;
  margin: 0 0 10px;
  color: #fff;
  text-align: left;
  font-size: 30.6px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.content9-wrapper .content9 .title-wrapper .title-content {
  position: relative;
  margin-bottom: 64px;
  text-align: left;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.content9-wrapper .content9 .content {
  min-height: 360px;
}
.content9-wrapper .content9 .content .content-year {
  color: #FFF;
  font-family: Montserrat;
  font-size: 120px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -3.2px;
  text-transform: uppercase;
}
.content9-wrapper .content9 .content .content-customer,
.content9-wrapper .content9 .content .content-project {
  color: #FFF;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.content9-wrapper .content9 .content .content-project {
  font-size: 16px;
}
@media screen and (max-width: 767px) {
  .content9-wrapper {
    padding-bottom: 0;
  }
  .content9-wrapper .content9 {
    min-height: 350px;
    padding: 64px 24px;
  }
  .content9-wrapper .content9 .content .content-year {
    color: #FFF;
    font-family: Montserrat;
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -3.2px;
    text-transform: uppercase;
  }
  .content9-wrapper .content9-body {
    min-height: 300px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: contain;
  }
  .content9-wrapper .content-btn-left {
    left: 5px;
  }
  .content9-wrapper .content-btn-right {
    right: 5px;
  }
  .content9-wrapper .block-wrapper {
    display: block;
    min-height: 100px;
    margin-bottom: 54px;
  }
  .content9-wrapper .image-wrapper,
  .content9-wrapper .text-wrapper {
    width: 100%;
  }
  .content9-wrapper .image-wrapper .block-img {
    display: none;
  }
  .content9-wrapper .image-wrapper .name-wrapper {
    text-align: left;
    float: left;
    width: 100%;
    padding-left: 40px;
    margin: auto;
  }
  .content9-wrapper .image-wrapper .block-name,
  .content9-wrapper .image-wrapper .block-post {
    display: inline-block;
  }
  .content9-wrapper .image-wrapper .block-name {
    margin-right: 8px;
  }
  .content9-wrapper .text-wrapper .block-content {
    display: none;
  }
  .content9-wrapper .text-wrapper .block-title {
    font-size: 16px;
  }
}
.content5-wrapper.home-page-wrapper {
  background-color: #fafafa;
  min-height: 720px;
}
.content5-wrapper.home-page-wrapper .title-wrapper {
  font-weight: 700;
}
.content5-wrapper.home-page-wrapper .title-wrapper .title-h1 {
  margin-bottom: 0;
  font-size: 30.6px;
}
.content5-wrapper.home-page-wrapper .title-wrapper .title-content {
  font-size: 16px;
  margin-bottom: 20px;
  font-family: Montserrat;
}
.content5-wrapper.home-page-wrapper .content5 > p {
  text-align: center;
}
.content5-wrapper.home-page-wrapper .content5 .con label {
  display: inline-block;
  min-width: 180px;
  line-height: 66px;
  background: #fff;
  text-align: center;
  font-size: 24px;
  color: #1890ff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 35px;
  border-left: 4px solid #1890ff;
  font-weight: 700;
  padding: 0 20px;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper {
  margin: 0 auto;
  left: 0;
  right: 0;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block {
  margin-bottom: 24px;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content {
  display: block;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid #e9e9e9;
  transform: translateY(0);
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
  border: none;
  color: rgba(0, 0, 0, 0.85);
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content:hover {
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-5px);
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content > span {
  width: 100%;
  height: 160px;
  display: block;
  background: #e9e9e9;
  padding: 5%;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content p {
  width: 100%;
  line-height: 30px;
}
.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content:hover p {
  bottom: 0;
}
@media screen and (max-width: 767px) {
  .content5-wrapper {
    height: auto;
    overflow: hidden;
  }
  .content5-wrapper .content5 ul li {
    display: block;
    width: 100%;
    padding: 2%;
  }
  .content5-wrapper .content5 ul li span {
    height: 168px;
  }
  .content5-wrapper .content5 ul li p {
    position: relative;
    bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/about/less/common.less","webpack://./src/views/about/less/index.less","webpack://./src/views/about/less/feature4.less","webpack://./src/views/about/less/teams1.less","webpack://./src/views/about/less/feature6.less","webpack://./src/views/about/less/feature7.less","webpack://./src/views/about/less/plan.less","webpack://./src/views/about/less/content9.less","webpack://./src/views/about/less/content5.less","webpack://./src/views/about/less/custom.less"],"names":[],"mappings":"AACA;EACE,qBAAA;ACAF;ADGA;;;;;;;;;;;;;;EAcE,SAAA;EACA,UAAA;ACDF;AACA;;;;GAIG;ADKH;EACE,gBAAA;ACHF;ADMA;EACE,gBAAA;ACJF;ADMA;EACE,UAAA;EACA,SAAA;ACJF;AACA;CACC;AClCA;EACC,iBAAA;EACA,yDAAA;ADoCF;ACtCC;EAKG,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;ADoCJ;AClCI;EAGI,mBAAA;ADkCR;ACrCI;EAOI,6BAAA;ADiCR;ACxCI;EAWI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADgCR;ACjDI;EAqBI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AD+BR;AC5DI;EAiCI,kBAAA;EACA,qBAAA;AD8BR;AChEI;EAqCM,mBAAA;AD8BV;ACnEI;EAwCQ,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AD8BZ;ACzEI;EA+CQ,kBAAA;EACA,eAAA;EACA,gBAAA;AD6BZ;AC9EI;EAqDQ,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD4BZ;ACtBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;ADwBN;ACtBM;EACE,gBAAA;ADwBR;ACjBA;EACG;IACC,aAAA;IACA,gBAAA;EDmBF;ECrBC;IAKG,cAAA;EDmBJ;ECjBI;;IAEE,cAAA;IACA,WAAA;EDmBN;EChBI;;IAGI,kBAAA;EDiBR;ECpBI;IAOI,sBAAA;EDgBR;ECvBI;IAWI,mBAAA;EDeR;ECXI;IACE,gBAAA;EDaN;ECVI;IACE,eAAA;EDYN;ECTI;IACE,mBAAA;EDWN;ECTM;IACE,kBAAA;EDWR;ECZM;IAII,kBAAA;EDWV;AACF;AEnJC;EACC,iBAAA;EACA,gBAAA;AFqJF;AEvJC;EAIG,gBAAA;EACA,YAAA;EACA,kBAAA;AFsJJ;AE5JC;EAQK,mBAAA;AFuJN;AE/JC;EAWO,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AFuJR;AExKC;EAoBO,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AFuJR;AEpLC;EAmCK,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AFoJN;AE1LC;EAyCO,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AFoJR;AElJQ;EACE,YAAA;AFoJV;AEnMC;EAmDS,WAAA;AFmJV;AEtMC;EAsDS,aAAA;AFmJV;AEzMC;EA0DS,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AFkJV;AEhNC;EAiEW,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AFkJZ;AE1NC;EA2EW,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AFkJZ;AEzIA;EACG;IACC,kBAAA;IACA,gBAAA;EF2IF;EE7IC;IAMK,WAAA;IACA,kBAAA;IACA,SAAA;IACA,gBAAA;EF0IN;EEnJC;IAaO,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;EFyIR;EE1JC;IAmBS,mBAAA;EF0IV;EE7JC;IAuBS,kBAAA;IACA,UAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EFyIV;EEvKC;IAkCS,kBAAA;IACA,UAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;IACA,qBAAA;EFwIV;AACF;AG7QE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AH+QJ;AGtQE;EACE,qBAAA;AHwQJ;AGtQI;EACE,kBAAA;EACA,mBAAA;AHwQN;AGrQI;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,mCAAA;EACA,eAAA;AHuQN;AGrQM;EACE,cAAA;AHuQR;AGnQI;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AHqQN;AGnQM;EACE,kBAAA;EACA,eAAA;EACA,kCAAA;AHqQR;AGhQE;;EAEE,gBAAA;AHkQJ;AG/PE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AHiQJ;AG/PI;EACE,gBAAA;AHiQN;AG5PE;EACE,eAAA;AH8PJ;AG3PE;EACE,eAAA;EACA,cAAA;AH6PJ;AGrUC;EA6EK,aAAA;AH2PN;AGxUC;EAkFO,kCAAA;AHyPR;AGtPM;EACE,mBAAA;AHwPR;AGlPA;EACG;IACC,iBAAA;EHoPF;EG1OE;IACE,cAAA;EH4OJ;EGzOE;IACE,UAAA;EH2OJ;EGvOC;IACC,eAAA;EHyOF;EGtOC;IACC,mBAAA;IAEE,kBAAA;EHuOJ;EG1OC;IAMK,kBAAA;EHuON;AACF;AIjWE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AJmWJ;AIlWI;EAEI,kBAAA;AJmWR;AI7VI;EACE,kBAAA;EACA,mBAAA;AJ+VN;AI7VI;EACE,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJ+VN;AI7VI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AJ+VN;AI3VE;EACE,wBAAA;AJ6VJ;AI1YC;EAkDK,uBAAA;AJ2VN;AI1VM;EACE,qBAAA;AJ4VR;AIhZC;EAwDK,sBAAA;AJ2VN;AIjTA;EACG;IACC,iBAAA;EJmTF;EIlTE;IAEI,kBAAA;EJmTN;EIrTE;IAKQ,cAAA;EJmTV;AACF;AK/ZC;EACC,oBAAA;ALiaF;AKhaE;EACE,iBAAA;ALkaJ;AKraC;EAMG,iBAAA;EACA,iBAAA;ALkaJ;AKzaC;EAUG,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4BAAA;EACA,wBAAA;ALkaJ;AKhbC;EAiBG,kBAAA;ALkaJ;AKjaI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,QAAA;EACA,0BAAA;EACA,cAAA;EACA,+BAAA;ALmaN;AK9bC;EA+BG,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;ALkaJ;AKjaI;EACE,gBAAA;ALmaN;AKxcC;;EA0CG,UAAA;ALkaJ;AK5cC;EA6CG,kBAAA;ALkaJ;AK/cC;;EAgDK,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ALmaN;AKtdC;EAsDK,YAAA;ALmaN;AKzdC;EAwDO,YAAA;ALoaR;AK5dC;EA4DK,gBAAA;ALmaN;AK/dC;EA8DO,eAAA;EACA,kBAAA;ALoaR;AKneC;EAkEO,eAAA;EACA,cAAA;ALoaR;AKveC;EAwEG,kBAAA;ALkaJ;AK1eC;EA0EK,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;ALmaN;AKhfC;EAgFK,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ALmaN;AKtfC;EAsFK,kBAAA;EACA,WAAA;EACA,uCAAA;ALmaN;AK3fC;EA2FK,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ALmaN;AK9ZA;EACG;IACC,iBAAA;ELgaF;EKjaC;IAGG,iBAAA;IACA,kBAAA;ELiaJ;EKraC;IAOG,iBAAA;IACA,yDAAA;IACA,4BAAA;IACA,4BAAA;IACA,wBAAA;ELiaJ;EK9ZI;IACE,OAAA;IACA,YAAA;IACA,SAAA;ELgaN;EKjbC;IAqBG,cAAA;IACA,iBAAA;IACA,mBAAA;EL+ZJ;EKtbC;;IA2BG,WAAA;EL+ZJ;EK1bC;IA+BK,aAAA;EL8ZN;EK7bC;IAkCK,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,YAAA;EL8ZN;EKpcC;;IAyCK,qBAAA;EL+ZN;EKxcC;IA4CK,iBAAA;EL+ZN;EK3cC;IAiDK,aAAA;EL6ZN;EK9cC;IAoDK,eAAA;EL6ZN;AACF;AMxjBC;EACC,kBAAA;EACA,gBAAA;EACA,yDAAA;EAEA,4BAAA;EACA,oBAAA;ANyjBF;AM/jBC;;EASG,kBAAA;EACA,QAAA;EACA,WAAA;AN0jBJ;AMrkBC;EAcG,WAAA;AN0jBJ;AMxkBC;EAiBG,YAAA;AN0jBJ;AM3kBC;EAiDG,iBAAA;AN6hBJ;AMxjBI;EACE,iBAAA;AN0jBN;AMjlBC;EA2BO,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ANyjBR;AM3lBC;EAqCO,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;ANyjBR;AMvmBC;EAmDK,iBAAA;ANujBN;AM1mBC;EAqDO,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;ANwjBR;AMpnBC;;EA+DO,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ANyjBR;AM5nBC;EAsEO,eAAA;ANyjBR;AMnjBA;EACG;IACC,iBAAA;ENqjBF;EMtjBC;IAGG,iBAAA;IACA,kBAAA;ENsjBJ;EM1jBC;IAQO,WAAA;IACA,uBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,sBAAA;IACA,yBAAA;ENqjBR;EMpkBC;IAoBG,iBAAA;IACA,yDAAA;IACA,4BAAA;IACA,4BAAA;IACA,wBAAA;ENmjBJ;EM3kBC;IA2BG,SAAA;ENmjBJ;EM9kBC;IA8BG,UAAA;ENmjBJ;EMjlBC;IAiCG,cAAA;IACA,iBAAA;IACA,mBAAA;ENmjBJ;EMtlBC;;IAuCG,WAAA;ENmjBJ;EM1lBC;IA2CK,aAAA;ENkjBN;EM7lBC;IA8CK,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,YAAA;ENkjBN;EMpmBC;;IAqDK,qBAAA;ENmjBN;EMxmBC;IAwDK,iBAAA;ENmjBN;EM3mBC;IA6DK,aAAA;ENijBN;EM9mBC;IAgEK,eAAA;ENijBN;AACF;AO7rBC;EACC,yBAAA;EACA,iBAAA;AP+rBF;AOjsBC;EAKG,gBAAA;AP+rBJ;AOpsBC;EAOK,gBAAA;EACA,iBAAA;APgsBN;AOxsBC;EAYK,eAAA;EACA,mBAAA;EACA,uBAAA;AP+rBN;AO7sBC;EAoBK,kBAAA;AP4rBN;AOhtBC;EAwBK,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AP2rBN;AOxrBI;EACE,cAAA;EACA,OAAA;EACA,QAAA;AP0rBN;AO7rBI;EAMI,mBAAA;AP0rBR;AOhsBI;EASM,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EChCR,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,6DAAA;ED+BQ,YAAA;EACA,0BAAA;EACA,6DAAA;AP6rBV;AQ7tBE;EARA,yCAAA;EAUE,2BAAA;AR+tBJ;AO/rBU;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;APisBZ;AO7rBU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AP+rBZ;AO5rBU;EACE,WAAA;EACA,iBAAA;AP8rBZ;AO1rBY;EACE,SAAA;AP4rBd;AOnrBA;EACG;IACC,YAAA;IACA,gBAAA;EPqrBF;EOvrBC;IAOO,cAAA;IACA,WAAA;IACA,WAAA;EPmrBR;EO5rBC;IAYS,aAAA;EPmrBV;EO/rBC;IAgBS,kBAAA;IACA,SAAA;EPkrBV;AACF","sourcesContent":["\nbody {\n  word-wrap: break-word;\n}\n\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n\n.video {\n  max-width: 800px;\n}\n\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n","body {\n  word-wrap: break-word;\n}\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n.video {\n  max-width: 800px;\n}\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n/* 详细页图片或框框的样式;\n*/\n.feature4-wrapper {\n  min-height: 500px;\n  background-image: url('~@/assets/about/background.png');\n}\n.feature4-wrapper .feature4 {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 50px 24px;\n}\n.feature4-wrapper .feature4-text .title-wrapper {\n  margin: 0 auto 35px;\n}\n.feature4-wrapper .feature4-text > *.queue-anim-leaving {\n  position: relative !important;\n}\n.feature4-wrapper .feature4-text .title-h1 {\n  position: relative;\n  margin: 0 0 5px;\n  text-align: left;\n  font-size: 30.6px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.feature4-wrapper .feature4-text .title-content {\n  position: relative;\n  text-align: left;\n  color: #3A4597;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.48px;\n  text-transform: uppercase;\n}\n.feature4-wrapper .feature4-text ul {\n  position: relative;\n  display: inline-block;\n}\n.feature4-wrapper .feature4-text ul li {\n  margin-bottom: 24px;\n}\n.feature4-wrapper .feature4-text ul li .feature4-icon {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n}\n.feature4-wrapper .feature4-text ul li .feature4-content {\n  line-height: 1.8em;\n  font-size: 16px;\n  text-indent: 2em;\n}\n.feature4-wrapper .feature4-text ul li .feature4-title {\n  font-size: 14px;\n  margin-bottom: 10px;\n  text-align: left;\n  color: #3A4597;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.feature4-wrapper .feature4-number {\n  font-size: 48px;\n  color: #0070E2;\n  font-weight: 700;\n  font-family: Montserrat;\n}\n.feature4-wrapper .feature4-number-wrapper {\n  text-align: left;\n}\n@media screen and (max-width: 576px) {\n  .feature4-wrapper {\n    padding: 10px;\n    overflow: hidden;\n  }\n  .feature4-wrapper .feature4 {\n    display: block;\n  }\n  .feature4-wrapper .feature4-img,\n  .feature4-wrapper .feature4-text {\n    display: block;\n    width: 100%;\n  }\n  .feature4-wrapper .feature4-text > h1,\n  .feature4-wrapper .feature4-text > p {\n    text-align: center;\n  }\n  .feature4-wrapper .feature4-text > h1 {\n    margin: 56px auto 16px;\n  }\n  .feature4-wrapper .feature4-text p {\n    margin-bottom: 32px;\n  }\n  .feature4-wrapper .feature4-img {\n    margin-top: 20px;\n  }\n  .feature4-wrapper .feature4-number {\n    font-size: 36px;\n  }\n  .feature4-wrapper .feature4-number-wrapper {\n    margin-bottom: 16px;\n  }\n  .feature4-wrapper .feature4-number-wrapper:nth-child(n+2) {\n    text-align: center;\n  }\n  .feature4-wrapper .feature4-number-wrapper:nth-child(n+2) p {\n    text-align: center;\n  }\n}\n.teams1-wrapper {\n  min-height: 446px;\n  overflow: hidden;\n}\n.teams1-wrapper .teams1 {\n  overflow: hidden;\n  height: 100%;\n  padding: 64px 24px;\n}\n.teams1-wrapper .teams1 > .title-wrapper {\n  margin: 0 27px 48px;\n}\n.teams1-wrapper .teams1 > .title-wrapper .title-h1 {\n  position: relative;\n  margin: 0 0 5px;\n  text-align: left;\n  font-size: 30.6px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.teams1-wrapper .teams1 > .title-wrapper .title-content {\n  position: relative;\n  margin-bottom: 64px;\n  text-align: left;\n  color: #3A4597;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.48px;\n  text-transform: uppercase;\n}\n.teams1-wrapper .teams1 .team-container {\n  width: 100%;\n  min-height: 530px;\n  margin: 0 27px 48px;\n  overflow: hidden;\n}\n.teams1-wrapper .teams1 .team-container label {\n  display: block;\n  height: 140px;\n  float: left;\n  margin-right: 20px;\n}\n.teams1-wrapper .teams1 .team-container label:nth-child(3) {\n  border: none;\n}\n.teams1-wrapper .teams1 .team-container label input:checked ~ div {\n  width: 30vw;\n}\n.teams1-wrapper .teams1 .team-container label input {\n  display: none;\n}\n.teams1-wrapper .teams1 .team-container label .city-container {\n  position: relative;\n  overflow: hidden;\n  width: 15vw;\n  transition: all 0.5s ease;\n  border-radius: 20px;\n}\n.teams1-wrapper .teams1 .team-container label .city-container .city-name {\n  position: absolute;\n  top: 300px;\n  left: 58px;\n  color: #FFF;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.teams1-wrapper .teams1 .team-container label .city-container .city-address {\n  position: absolute;\n  top: 350px;\n  left: 62px;\n  color: #FFF;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n@media screen and (max-width: 767px) {\n  .teams1-wrapper {\n    min-height: 1000px;\n    overflow: hidden;\n  }\n  .teams1-wrapper .teams1 .team-container {\n    width: 100%;\n    min-height: 1000px;\n    margin: 0;\n    overflow: hidden;\n  }\n  .teams1-wrapper .teams1 .team-container .city-container {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    height: 250px;\n    margin-bottom: 20px;\n  }\n  .teams1-wrapper .teams1 .team-container .city-container img {\n    border-radius: 20px;\n  }\n  .teams1-wrapper .teams1 .team-container .city-container .city-name {\n    position: absolute;\n    top: 120px;\n    left: 10px;\n    color: #FFF;\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  .teams1-wrapper .teams1 .team-container .city-container .city-address {\n    position: absolute;\n    top: 160px;\n    left: 10px;\n    color: #FFF;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    width: 300px;\n    white-space: pre-wrap;\n  }\n}\n.feature6-wrapper {\n  min-height: 360px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n.feature6-title {\n  display: inline-block;\n}\n.feature6-title-wrapper {\n  text-align: center;\n  margin-bottom: 48px;\n}\n.feature6-title-text {\n  display: inline-block;\n  margin: 0 72px;\n  font-size: 24px;\n  color: rgba(0, 0, 0, 0.85);\n  transition: color 0.45s ease-in-out;\n  cursor: pointer;\n}\n.feature6-title-text.active {\n  color: #0070E2;\n}\n.feature6-title-bar {\n  height: 6px;\n  background: #0070E2;\n  width: 20%;\n  margin: auto;\n  display: block;\n}\n.feature6-title-bar-wrapper {\n  position: relative;\n  margin-top: 8px;\n  transition: left 0.45s ease-in-out;\n}\n.feature6-number,\n.feature6-text {\n  text-align: left;\n}\n.feature6-number {\n  font-size: 48px;\n  color: #0070E2;\n  font-weight: 700;\n  font-family: Montserrat;\n}\n.feature6-number-wrapper {\n  text-align: left;\n}\n.feature6-text {\n  font-size: 20px;\n}\n.feature6-unit {\n  font-size: 16px;\n  color: #0070E2;\n}\n.feature6 .ant-carousel .slick-dots-bottom {\n  bottom: -24px;\n}\n.feature6 .ant-carousel .slick-dots li button {\n  background: rgba(0, 112, 226, 0.3);\n}\n.feature6 .ant-carousel .slick-dots li.slick-active button {\n  background: #0070E2;\n}\n@media screen and (max-width: 576px) {\n  .feature6-wrapper {\n    padding-bottom: 0;\n  }\n  .feature6-title-text {\n    margin: 0 14px;\n  }\n  .feature6-title-bar {\n    width: 40%;\n  }\n  .feature6-number {\n    font-size: 36px;\n  }\n  .feature6-number-wrapper {\n    margin-bottom: 16px;\n    text-align: center;\n  }\n  .feature6-number-wrapper p {\n    text-align: center;\n  }\n}\n.feature7-wrapper {\n  min-height: 564px;\n  margin: 0 auto;\n  overflow: hidden;\n  background-color: #f7f9fc;\n  background-image: url('~@/assets/about/honors_bg.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.feature7-wrapper.home-page-wrapper .home-page {\n  padding: 64px 24px;\n}\n.feature7-title-wrapper {\n  text-align: center;\n  margin-bottom: 40px;\n}\n.feature7-title-h1 {\n  padding-left: 24px;\n  font-size: 30.6px;\n  color: rgba(0, 0, 0, 0.85);\n  text-align: left;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.feature7-title-content {\n  padding-left: 24px;\n  margin-top: 16px;\n  text-align: left;\n  color: #3A4597;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.48px;\n  text-transform: uppercase;\n}\n.feature7-text {\n  margin: 100px 0 0 350px ;\n}\n.feature7 ul li {\n  list-style-type: circle;\n}\n.feature7 ul li:last-child {\n  list-style-type: none;\n}\n.feature7 ul .content7-content {\n  padding: 0 0 25px 10px;\n}\n@media screen and (max-width: 767px) {\n  .feature7-wrapper {\n    min-height: 840px;\n  }\n  .feature7-wrapper.home-page-wrapper .home-page {\n    padding: 56px 24px;\n  }\n  .feature7-wrapper.home-page-wrapper .home-page .feature7-mobile .active {\n    color: #0070E2;\n  }\n}\n.plan-wrapper {\n  padding-bottom: 64px;\n}\n.plan-wrapper.home-page-wrapper {\n  overflow: initial;\n}\n.plan-wrapper .plan {\n  min-height: 450px;\n  padding: 64px 0 0;\n}\n.plan-wrapper .plan-body {\n  min-height: 540px;\n  background-image: url('~@/assets/about/feature_plan.png');\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: contain;\n}\n.plan-wrapper .timeline {\n  position: relative;\n}\n.plan-wrapper .timeline:before {\n  display: block;\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  width: 0;\n  height: calc(100% - 108px);\n  margin: 34px 0;\n  border-left: 2px #ebedf0 dashed;\n}\n.plan-wrapper .block-wrapper {\n  color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  position: relative;\n  margin-bottom: 70px;\n  min-height: 160px;\n}\n.plan-wrapper .block-wrapper:last-child {\n  margin-bottom: 0;\n}\n.plan-wrapper .image-wrapper,\n.plan-wrapper .text-wrapper {\n  width: 50%;\n}\n.plan-wrapper .image-wrapper {\n  text-align: center;\n}\n.plan-wrapper .image-wrapper .block-img,\n.plan-wrapper .image-wrapper .name-wrapper {\n  float: right;\n  clear: both;\n  width: 262px;\n  margin: auto;\n}\n.plan-wrapper .image-wrapper .block-img {\n  height: 98px;\n}\n.plan-wrapper .image-wrapper .block-img img {\n  height: 100%;\n}\n.plan-wrapper .image-wrapper .name-wrapper {\n  margin: 16px 0 0;\n}\n.plan-wrapper .image-wrapper .name-wrapper .block-name {\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n.plan-wrapper .image-wrapper .name-wrapper .block-post {\n  font-size: 12px;\n  color: #697b8c;\n}\n.plan-wrapper .text-wrapper {\n  padding-left: 40px;\n}\n.plan-wrapper .text-wrapper .block-time {\n  font-size: 12px;\n  color: #697b8c;\n  line-height: 18px;\n  min-height: 18px;\n}\n.plan-wrapper .text-wrapper .block-title {\n  margin: 8px 0 12px;\n  font-size: 14px;\n  position: relative;\n  min-height: 18px;\n}\n.plan-wrapper .text-wrapper .block-icon {\n  position: absolute;\n  left: -40px;\n  transform: translateX(calc(-50% + 1px));\n}\n.plan-wrapper .text-wrapper .block-content {\n  width: 300px;\n  color: #314659;\n  font-size: 12px;\n  min-height: 18px;\n}\n@media screen and (max-width: 767px) {\n  .plan-wrapper {\n    padding-bottom: 0;\n  }\n  .plan-wrapper .plan {\n    min-height: 350px;\n    padding: 64px 24px;\n  }\n  .plan-wrapper .plan-body {\n    min-height: 300px;\n    background-image: url('~@/assets/about/process.png');\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: contain;\n  }\n  .plan-wrapper .timeline:before {\n    left: 0;\n    height: 100%;\n    margin: 0;\n  }\n  .plan-wrapper .block-wrapper {\n    display: block;\n    min-height: 100px;\n    margin-bottom: 54px;\n  }\n  .plan-wrapper .image-wrapper,\n  .plan-wrapper .text-wrapper {\n    width: 100%;\n  }\n  .plan-wrapper .image-wrapper .block-img {\n    display: none;\n  }\n  .plan-wrapper .image-wrapper .name-wrapper {\n    text-align: left;\n    float: left;\n    width: 100%;\n    padding-left: 40px;\n    margin: auto;\n  }\n  .plan-wrapper .image-wrapper .block-name,\n  .plan-wrapper .image-wrapper .block-post {\n    display: inline-block;\n  }\n  .plan-wrapper .image-wrapper .block-name {\n    margin-right: 8px;\n  }\n  .plan-wrapper .text-wrapper .block-content {\n    display: none;\n  }\n  .plan-wrapper .text-wrapper .block-title {\n    font-size: 16px;\n  }\n}\n.content9-wrapper {\n  position: relative;\n  margin-top: 40px;\n  background-image: url('~@/assets/about/history_bg.png');\n  background-repeat: no-repeat;\n  padding-bottom: 64px;\n}\n.content9-wrapper .content-btn-left,\n.content9-wrapper .content-btn-right {\n  position: absolute;\n  top: 70%;\n  z-index: 11;\n}\n.content9-wrapper .content-btn-left {\n  left: -40px;\n}\n.content9-wrapper .content-btn-right {\n  right: -40px;\n}\n.content9-wrapper .content9 {\n  min-height: 350px;\n}\n.content9-wrapper .content9.home-page-wrapper {\n  overflow: initial;\n}\n.content9-wrapper .content9 .title-wrapper .title-h1 {\n  position: relative;\n  margin: 0 0 10px;\n  color: #fff;\n  text-align: left;\n  font-size: 30.6px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.content9-wrapper .content9 .title-wrapper .title-content {\n  position: relative;\n  margin-bottom: 64px;\n  text-align: left;\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.48px;\n  text-transform: uppercase;\n}\n.content9-wrapper .content9 .content {\n  min-height: 360px;\n}\n.content9-wrapper .content9 .content .content-year {\n  color: #FFF;\n  font-family: Montserrat;\n  font-size: 120px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -3.2px;\n  text-transform: uppercase;\n}\n.content9-wrapper .content9 .content .content-customer,\n.content9-wrapper .content9 .content .content-project {\n  color: #FFF;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.content9-wrapper .content9 .content .content-project {\n  font-size: 16px;\n}\n@media screen and (max-width: 767px) {\n  .content9-wrapper {\n    padding-bottom: 0;\n  }\n  .content9-wrapper .content9 {\n    min-height: 350px;\n    padding: 64px 24px;\n  }\n  .content9-wrapper .content9 .content .content-year {\n    color: #FFF;\n    font-family: Montserrat;\n    font-size: 45px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: -3.2px;\n    text-transform: uppercase;\n  }\n  .content9-wrapper .content9-body {\n    min-height: 300px;\n    background-image: url('~@/assets/about/process.png');\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: contain;\n  }\n  .content9-wrapper .content-btn-left {\n    left: 5px;\n  }\n  .content9-wrapper .content-btn-right {\n    right: 5px;\n  }\n  .content9-wrapper .block-wrapper {\n    display: block;\n    min-height: 100px;\n    margin-bottom: 54px;\n  }\n  .content9-wrapper .image-wrapper,\n  .content9-wrapper .text-wrapper {\n    width: 100%;\n  }\n  .content9-wrapper .image-wrapper .block-img {\n    display: none;\n  }\n  .content9-wrapper .image-wrapper .name-wrapper {\n    text-align: left;\n    float: left;\n    width: 100%;\n    padding-left: 40px;\n    margin: auto;\n  }\n  .content9-wrapper .image-wrapper .block-name,\n  .content9-wrapper .image-wrapper .block-post {\n    display: inline-block;\n  }\n  .content9-wrapper .image-wrapper .block-name {\n    margin-right: 8px;\n  }\n  .content9-wrapper .text-wrapper .block-content {\n    display: none;\n  }\n  .content9-wrapper .text-wrapper .block-title {\n    font-size: 16px;\n  }\n}\n.content5-wrapper.home-page-wrapper {\n  background-color: #fafafa;\n  min-height: 720px;\n}\n.content5-wrapper.home-page-wrapper .title-wrapper {\n  font-weight: 700;\n}\n.content5-wrapper.home-page-wrapper .title-wrapper .title-h1 {\n  margin-bottom: 0;\n  font-size: 30.6px;\n}\n.content5-wrapper.home-page-wrapper .title-wrapper .title-content {\n  font-size: 16px;\n  margin-bottom: 20px;\n  font-family: Montserrat;\n}\n.content5-wrapper.home-page-wrapper .content5 > p {\n  text-align: center;\n}\n.content5-wrapper.home-page-wrapper .content5 .con label {\n  display: inline-block;\n  min-width: 180px;\n  line-height: 66px;\n  background: #fff;\n  text-align: center;\n  font-size: 24px;\n  color: #1890ff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 35px;\n  border-left: 4px solid #1890ff;\n  font-weight: 700;\n  padding: 0 20px;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper {\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block {\n  margin-bottom: 24px;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content {\n  display: block;\n  background: #fff;\n  border-radius: 4px;\n  padding: 10px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border-radius: 6px;\n  border: 1px solid #e9e9e9;\n  transform: translateY(0);\n  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;\n  border: none;\n  color: rgba(0, 0, 0, 0.85);\n  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content:hover {\n  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-5px);\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content > span {\n  width: 100%;\n  height: 160px;\n  display: block;\n  background: #e9e9e9;\n  padding: 5%;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content p {\n  width: 100%;\n  line-height: 30px;\n}\n.content5-wrapper.home-page-wrapper .content5-img-wrapper .block .content5-block-content:hover p {\n  bottom: 0;\n}\n@media screen and (max-width: 767px) {\n  .content5-wrapper {\n    height: auto;\n    overflow: hidden;\n  }\n  .content5-wrapper .content5 ul li {\n    display: block;\n    width: 100%;\n    padding: 2%;\n  }\n  .content5-wrapper .content5 ul li span {\n    height: 168px;\n  }\n  .content5-wrapper .content5 ul li p {\n    position: relative;\n    bottom: 0;\n  }\n}\n","@feature4: feature4;\n@primary-color: #0070E2;\n.@{feature4}-wrapper {\n  min-height: 500px;\n  background-image: url('~@/assets/about/background.png');\n\n  .@{feature4} {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 50px 24px;\n\n    &-text {\n\n      .title-wrapper {\n        margin: 0 auto 35px;\n      }\n\n      > *.queue-anim-leaving {\n        position: relative !important;\n      }\n\n      .title-h1 {\n        position: relative;\n        margin: 0 0 5px;\n        text-align: left;\n        font-size: 30.6px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n\n      .title-content {\n        position: relative;\n        text-align: left;\n        color: #3A4597;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        letter-spacing: -0.48px;\n        text-transform: uppercase;\n      }\n\n      ul {\n        position: relative;\n        display: inline-block;\n\n        li {\n          margin-bottom: 24px;\n\n          .@{feature4}-icon {\n            display: inline-block;\n            width: 30px;\n            height: 30px;\n            position: absolute;\n          }\n\n          .@{feature4}-content {\n            line-height: 1.8em;\n            font-size: 16px;\n            text-indent: 2em;\n          }\n\n          .@{feature4}-title {\n            font-size: 14px;\n            margin-bottom: 10px;\n            text-align: left;\n            color: #3A4597;\n            font-size: 24px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n          }\n        }\n      }\n    }\n\n    &-number {\n      font-size: 48px;\n      color: @primary-color;\n      font-weight: 700;\n      font-family: Montserrat;\n\n      &-wrapper {\n        text-align: left;\n        //padding-left: 7%;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .@{feature4}-wrapper {\n    padding: 10px;\n    overflow: hidden;\n\n    .@{feature4} {\n      display: block;\n\n      &-img,\n      &-text {\n        display: block;\n        width: 100%;\n      }\n\n      &-text {\n        > h1,\n        > p {\n          text-align: center;\n        }\n\n        > h1 {\n          margin: 56px auto 16px;\n        }\n\n        p {\n          margin-bottom: 32px;\n        }\n      }\n\n      &-img {\n        margin-top: 20px;\n      }\n\n      &-number {\n        font-size: 36px;\n      }\n\n      &-number-wrapper {\n        margin-bottom: 16px;\n\n        &:nth-child(n+2) {\n          text-align: center;\n\n          p {\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n}\n","@teams1: teams1;\n.@{teams1}-wrapper {\n  min-height: 446px;\n  overflow: hidden;\n  .@{teams1} {\n    overflow: hidden;\n    height: 100%;\n    padding: 64px 24px;\n    > .title-wrapper {\n      margin: 0 27px 48px;\n\n      .title-h1 {\n        position: relative;\n        margin: 0 0 5px;\n        text-align: left;\n        font-size: 30.6px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n      .title-content {\n        position: relative;\n        margin-bottom: 64px;\n        text-align: left;\n        color: #3A4597;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        letter-spacing: -0.48px;\n        text-transform: uppercase;\n      }\n    }\n\n\n    .team-container {\n      width: 100%;\n      min-height: 530px;\n      margin: 0 27px 48px;\n      overflow: hidden;\n      // box-shadow: 0 4px 10px rgba(0, 0, 0, .5);\n      label {\n        display: block;\n        height: 140px;\n        float: left;\n        margin-right: 20px;\n\n        &:nth-child(3) {\n          border: none;\n        }\n\n        input:checked~div {\n          width: 30vw;\n        }\n        input {\n          display: none;\n        }\n\n        .city-container {\n          position: relative;\n          overflow: hidden;\n          width: 15vw;\n          transition: all .5s ease;\n          border-radius: 20px;\n\n          .city-name {\n            position: absolute;\n            top: 300px;\n            left: 58px;\n            color: #FFF;\n            font-size: 36px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n          }\n          .city-address {\n            position: absolute;\n            top: 350px;\n            left: 62px;\n            color: #FFF;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{teams1}-wrapper {\n    min-height: 1000px;\n    overflow: hidden;\n\n    .@{teams1} {\n      .team-container {\n        width: 100%;\n        min-height: 1000px;\n        margin: 0;\n        overflow: hidden;\n        // box-shadow: 0 4px 10px rgba(0, 0, 0, .5);\n\n        .city-container {\n          position: relative;\n          overflow: hidden;\n          width: 100%;\n          height: 250px;\n          margin-bottom: 20px;\n          img {\n            border-radius: 20px;\n          }\n\n          .city-name {\n            position: absolute;\n            top: 120px;\n            left: 10px;\n            color: #FFF;\n            font-size: 30px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n          }\n\n          .city-address {\n            position: absolute;\n            top: 160px;\n            left: 10px;\n            color: #FFF;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            width: 300px;\n            white-space: pre-wrap;\n          }\n        }\n      }\n    }\n  }\n}\n","@feature6: feature6;\n@primary-color: #0070E2;\n\n.@{feature6} {\n  &-wrapper {\n    min-height: 360px;\n    margin: 0 auto;\n    overflow: hidden;\n\n    // &.home-page-wrapper {\n    //   .home-page {\n    //     padding: 64px 24px;\n    //   }\n    // }\n  }\n\n  &-title {\n    display: inline-block;\n\n    &-wrapper {\n      text-align: center;\n      margin-bottom: 48px;\n    }\n\n    &-text {\n      display: inline-block;\n      margin: 0 72px;\n      font-size: 24px;\n      color: @text-color;\n      transition: color .45s @ease-in-out;\n      cursor: pointer;\n\n      &.active {\n        color: @primary-color;\n      }\n    }\n\n    &-bar {\n      height: 6px;\n      background: @primary-color;\n      width: 20%;\n      margin: auto;\n      display: block;\n\n      &-wrapper {\n        position: relative;\n        margin-top: 8px;\n        transition: left .45s @ease-in-out;\n      }\n    }\n  }\n\n  &-number,\n  &-text {\n    text-align: left;\n  }\n\n  &-number {\n    font-size: 48px;\n    color: @primary-color;\n    font-weight: 700;\n    font-family: Montserrat;\n\n    &-wrapper {\n      text-align: left;\n      //padding-left: 7%;\n    }\n  }\n\n  &-text {\n    font-size: 20px;\n  }\n\n  &-unit {\n    font-size: 16px;\n    color: @primary-color;\n  }\n\n  .ant-carousel {\n    .slick-dots-bottom {\n      bottom: -24px;\n    }\n\n    .slick-dots li {\n      button {\n        background: fade(@primary-color, 30);\n      }\n\n      &.slick-active button {\n        background: @primary-color;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .@{feature6}-wrapper {\n    padding-bottom: 0;\n\n    // &.home-page-wrapper {\n    //   .home-page {\n    //     padding: 56px 24px 64px;\n    //   }\n    // }\n  }\n\n  .@{feature6}-title {\n    &-text {\n      margin: 0 14px;\n    }\n\n    &-bar {\n      width: 40%;\n    }\n  }\n\n  .@{feature6}-number {\n    font-size: 36px;\n  }\n\n  .@{feature6}-number-wrapper {\n    margin-bottom: 16px;\n\n      text-align: center;\n\n      p {\n        text-align: center;\n      }\n  }\n}\n","@feature7: feature7;\n@ease-in-out: ease-in-out;\n@primary-color: #0070E2;\n\n.@{feature7} {\n  &-wrapper {\n    min-height: 564px;\n    margin: 0 auto;\n    overflow: hidden;\n    background-color: #f7f9fc;\n    background-image: url('~@/assets/about/honors_bg.png');\n    background-size: contain;\n    background-repeat: no-repeat;\n    &.home-page-wrapper {\n      .home-page {\n        padding: 64px 24px;\n      }\n    }\n  }\n\n  &-title {\n    &-wrapper {\n      text-align: center;\n      margin-bottom: 40px;\n    }\n    &-h1 {\n      padding-left: 24px;\n      font-size: 30.6px;\n      color: @text-color;\n      text-align: left;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n    &-content {\n      padding-left: 24px;\n      margin-top: 16px;\n      text-align: left;\n      color: #3A4597;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      letter-spacing: -0.48px;\n      text-transform: uppercase;\n    }\n  }\n\n  &-text {\n    margin: 100px 0 0 350px ;\n  }\n\n  ul {\n    li {\n      list-style-type: circle;\n      &:last-child {\n        list-style-type: none;\n      }\n    }\n    .content7-content {\n      padding: 0 0 25px 10px;\n    }\n  }\n\n  // &-block {\n  //   margin-top: 28px;\n\n  //   &-group {\n  //     display: block;\n  //     padding: 28px 24px;\n  //     box-shadow: 0 2px 16px fade(#000, 8);\n  //     background-image: url('https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*fMOFSpRXMxsAAAAAAAAAAABkARQnAQ');\n  //     background-repeat: no-repeat;\n  //     background-position: 100% 100%;\n  //     transition: box-shadow @animate-duration @ease-in-out, transform @animate-duration @ease-in-out;\n\n  //     &:hover {\n  //       transform: translateY(-5px);\n  //       box-shadow: 0 6px 16px fade(#000, 12);\n  //     }\n  //   }\n\n  //   &-image {\n  //     float: left;\n  //     width: 24px;\n  //   }\n\n  //   &-title {\n  //     font-size: 14px;\n  //     float: left;\n  //     margin-left: 8px;\n  //     margin-bottom: 16px;\n  //     color: @text-color;\n  //   }\n\n  //   &-content {\n  //     clear: both;\n  //     color: fade(@text-color, 75);\n  //   }\n  // }\n}\n\n@media screen and (max-width: 767px) {\n  .@{feature7}-wrapper {\n    min-height: 840px;\n    &.home-page-wrapper {\n      .home-page {\n        padding: 56px 24px;\n        .feature7-mobile {\n          .active {\n            color: @primary-color;\n          }\n        }\n      }\n    }\n  }\n}\n","@plan: plan;\n@text-color: rgba(0, 0, 0, 0.85);\n@text-color2: #697b8c;\n.@{plan}-wrapper {\n  padding-bottom: 64px;\n  &.home-page-wrapper {\n    overflow: initial;\n  }\n  .@{plan} {\n    min-height: 450px;\n    padding: 64px 0 0;\n  }\n  .@{plan}-body {\n    min-height: 540px;\n    background-image: url('~@/assets/about/feature_plan.png');\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size:contain;\n  }\n  .timeline {\n    position: relative;\n    &:before {\n      display: block;\n      content: '';\n      position: absolute;\n      left: 50%;\n      top: 0;\n      width: 0;\n      height: ~\"calc(100% - 108px)\";\n      margin: 34px 0;\n      border-left: 2px #ebedf0 dashed;\n    }\n  }\n  .block-wrapper {\n    color: @text-color;\n    display: flex;\n    position: relative;\n    margin-bottom: 70px;\n    min-height: 160px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  .image-wrapper,\n  .text-wrapper {\n    width: 50%;\n  }\n  .image-wrapper {\n    text-align: center;\n    .block-img,\n    .name-wrapper {\n      float: right;\n      clear: both;\n      width: 262px;\n      margin: auto;\n    }\n    .block-img {\n      height: 98px;\n      img {\n        height: 100%;\n      }\n    }\n    .name-wrapper {\n      margin: 16px 0 0;\n      .block-name {\n        font-size: 14px;\n        margin-bottom: 4px;\n      }\n      .block-post {\n        font-size: 12px;\n        color: @text-color2;\n      }\n    }\n  }\n  .text-wrapper {\n    padding-left: 40px;\n    .block-time {\n      font-size: 12px;\n      color: @text-color2;\n      line-height: 18px;\n      min-height: 18px;\n    }\n    .block-title {\n      margin: 8px 0 12px;\n      font-size: 14px;\n      position: relative;\n      min-height: 18px;\n    }\n    .block-icon {\n      position: absolute;\n      left: -40px;\n      transform: translateX(~\"calc(-50% + 1px)\");\n    }\n    .block-content {\n      width: 300px;\n      color: #314659;\n      font-size: 12px;\n      min-height: 18px;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{plan}-wrapper {\n    padding-bottom: 0;\n    .@{plan} {\n      min-height: 350px;\n      padding: 64px 24px;\n    }\n    .@{plan}-body {\n      min-height: 300px;\n      background-image: url('~@/assets/about/process.png');\n      background-repeat: no-repeat;\n      background-attachment: fixed;\n      background-size:contain;\n    }\n    .timeline {\n      &:before {\n        left: 0;\n        height: 100%;\n        margin: 0;\n      }\n    }\n    .block-wrapper {\n      display: block;\n      min-height: 100px;\n      margin-bottom: 54px;\n    }\n    .image-wrapper,\n    .text-wrapper {\n      width: 100%;\n    }\n    .image-wrapper {\n      .block-img {\n        display: none;\n      }\n      .name-wrapper {\n        text-align: left;\n        float: left;\n        width: 100%;\n        padding-left: 40px;\n        margin: auto;\n      }\n      .block-name, .block-post {\n        display: inline-block;\n      }\n      .block-name {\n        margin-right: 8px;\n      }\n    }\n    .text-wrapper {\n      .block-content {\n        display: none;\n      }\n      .block-title {\n        font-size: 16px;\n      }\n    }\n  }\n}\n","@content9: content9;\n.@{content9}-wrapper {\n  position: relative;\n  margin-top: 40px;\n  background-image: url('~@/assets/about/history_bg.png');\n  // background-size: contain;\n  background-repeat: no-repeat;\n  padding-bottom: 64px;\n\n  .content-btn-left, .content-btn-right {\n    position: absolute;\n    top: 70%;\n    z-index: 11;\n  }\n  .content-btn-left {\n    left: -40px;\n  }\n  .content-btn-right {\n    right: -40px;\n  }\n\n  .@{content9} {\n    // padding-top: 24px;\n    &.home-page-wrapper {\n      overflow: initial;\n    }\n    .title-wrapper {\n      .title-h1 {\n        position: relative;\n        margin: 0 0 10px;\n        color: #fff;\n        text-align: left;\n        font-size: 30.6px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n      .title-content {\n        position: relative;\n        margin-bottom: 64px;\n        text-align: left;\n        color: #fff;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        letter-spacing: -0.48px;\n        text-transform: uppercase;\n      }\n    }\n    min-height: 350px;\n    .content {\n      min-height: 360px;\n      .content-year {\n        color: #FFF;\n        font-family: Montserrat;\n        font-size: 120px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        letter-spacing: -3.2px;\n        text-transform: uppercase;\n      }\n      .content-customer, .content-project {\n        color: #FFF;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n      .content-project {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content9}-wrapper {\n    padding-bottom: 0;\n    .@{content9} {\n      min-height: 350px;\n      padding: 64px 24px;\n\n      .content {\n        .content-year {\n          color: #FFF;\n          font-family: Montserrat;\n          font-size: 45px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n          letter-spacing: -3.2px;\n          text-transform: uppercase;\n        }\n      }\n    }\n    .@{content9}-body {\n      min-height: 300px;\n      background-image: url('~@/assets/about/process.png');\n      background-repeat: no-repeat;\n      background-attachment: fixed;\n      background-size:contain;\n    }\n    .content-btn-left {\n      left: 5px;\n    }\n    .content-btn-right {\n      right: 5px;\n    }\n    .block-wrapper {\n      display: block;\n      min-height: 100px;\n      margin-bottom: 54px;\n    }\n    .image-wrapper,\n    .text-wrapper {\n      width: 100%;\n    }\n    .image-wrapper {\n      .block-img {\n        display: none;\n      }\n      .name-wrapper {\n        text-align: left;\n        float: left;\n        width: 100%;\n        padding-left: 40px;\n        margin: auto;\n      }\n      .block-name, .block-post {\n        display: inline-block;\n      }\n      .block-name {\n        margin-right: 8px;\n      }\n    }\n    .text-wrapper {\n      .block-content {\n        display: none;\n      }\n      .block-title {\n        font-size: 16px;\n      }\n    }\n  }\n}\n","@ease-out: ease-out;\n\n@content5: content5;\n.@{content5}-wrapper.home-page-wrapper {\n  background-color: #fafafa;\n  min-height: 720px;\n\n  .title-wrapper {\n    font-weight: 700;\n    .title-h1 {\n      margin-bottom: 0;\n      font-size: 30.6px;\n    }\n\n    .title-content {\n      font-size: 16px;\n      margin-bottom: 20px;\n      font-family: Montserrat;\n    }\n  }\n\n  .@{content5} {\n    > p {\n      text-align: center;\n    }\n\n    .con label {\n      display: inline-block;\n      min-width: 180px;\n      line-height: 66px;\n      background: #fff;\n      text-align: center;\n      font-size: 24px;\n      color: #1890ff;\n      box-shadow: 0 0 10px rgba(0, 0, 0, .1);\n      margin-bottom: 35px;\n      border-left: 4px solid #1890ff;\n      font-weight: 700;\n      padding: 0 20px;\n    }\n\n    &-img-wrapper {\n      margin: 0 auto;\n      left: 0;\n      right: 0;\n\n      .block {\n        margin-bottom: 24px;\n\n        .content5-block-content {\n          display: block;\n          background: #fff;\n          border-radius: 4px;\n          padding: 10px;\n          text-align: center;\n          position: relative;\n          overflow: hidden;\n          .page-pro();\n          border: none;\n          color: @text-color;\n          transition: box-shadow .3s @ease-out, transform .3s @ease-out;\n\n          & > span {\n            width: 100%;\n            height: 160px;\n            display: block;\n            background: @line-color;\n            padding: 5%;\n          }\n\n\n          & img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n          }\n\n          & p {\n            width: 100%;\n            line-height: 30px;\n          }\n\n          &:hover {\n            & p {\n              bottom: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content5}-wrapper {\n    height: auto;\n    overflow: hidden;\n\n    .@{content5} {\n      ul {\n        li {\n          display: block;\n          width: 100%;\n          padding: 2%;\n\n          span {\n            height: 168px;\n          }\n\n          p {\n            position: relative;\n            bottom: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","@line-color: #e9e9e9;\n\n@shadow-color: rgba(0, 0, 0, 0.15);\n\n@bottom-bar-bg-color: #262626;\n@bottom-bar-line-color: #000;\n\n@template-bg-color: #001529;\n@template-bg-color-light: #ececec;\n@template-nav-bg-color: #001529;\n@template-text-color: #ccc;\n@template-text-title-color: #bcbcbc;\n@template-text-color-light: #fff;\n@template-footer-text-color: #999;\n\n@animate-duration: .45s;\n\n/* 详细页图片或框框的样式;\n*/\n.page-shadow() {\n  box-shadow: 0 5px 8px @shadow-color;\n}\n\n.page-pro() {\n  border-radius: 6px;\n  border: 1px solid @line-color;\n  transform: translateY(0);\n  transition: transform .3s @ease-out, box-shadow .3s @ease-out;\n  &:hover {\n    .page-shadow();\n    transform: translateY(-5px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
